import { Dialog, DialogContent } from "@bleu.builders/ui";
import React from "react";

export const MobileDialog = () => {
  const [open, setOpen] = React.useState(true);

  return (
    <Dialog aria-labelledby="mobile" open={open} onOpenChange={setOpen}>
      <DialogContent
        aria-label="mobile"
        className="sm:max-w-[550px] p-6 flex flex-col gap-4 bg-background dark:border-2 rounded-lg shadow-xl mr-10"
      >
        <div className="flex flex-col items-center text-center">
          <h2 className="text-xl font-bold">Atenção</h2>
          <p className="text-sm text-muted-foreground mt-2">
            Este aplicativo foi construído para uso em desktops. Para a melhor
            experiência, utilize um computador.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};
